import type { AlienGlossaryEntry } from './types';

export const alienInvasionGlossary: AlienGlossaryEntry[] = [
  {
    "id": "ai:glossary:active-trooper",
    "term": "Aktywny oddział Obcych",
    "definition": "Stojący pion oddziału Obcych.",
    "scenarioIds": [
      "invasion"
    ]
  },
  {
    "id": "ai:glossary:stunned",
    "term": "Ogłuszony oddział",
    "definition": "Leżący pion Obcego. Może zostać podniesiony za 1 punkt ruchu.",
    "scenarioIds": [
      "invasion"
    ]
  },
  {
    "id": "ai:glossary:corruption",
    "term": "R&D Corruption",
    "definition": "Znacznik blokujący rozwój ludzkiej technologii, lecz nie jej używanie.",
    "scenarioIds": [
      "invasion"
    ]
  },
  {
    "id": "ai:glossary:infected",
    "term": "Zakażony kolonista",
    "definition": "Leżący kolonista, który na końcu tury zakaża współdzielących z nim obszar.",
    "scenarioIds": [
      "outbreak"
    ]
  },
  {
    "id": "ai:glossary:vandalized",
    "term": "Zdewastowany budynek",
    "definition": "Budynek z pustym tokenem Blackout; nadal działa.",
    "scenarioIds": [
      "blackout"
    ]
  },
  {
    "id": "ai:glossary:blackout",
    "term": "Budynek w blackout",
    "definition": "Budynek z tokenem Blackout i leżącym kolonistą; nie działa, nie produkuje i nie liczy się do kompleksu.",
    "scenarioIds": [
      "blackout"
    ]
  },
  {
    "id": "ai:glossary:sabotage-row",
    "term": "Rząd sabotażu",
    "definition": "Ciąg kart sabotażu w Monolith, na których gromadzą się kostki według liter.",
    "scenarioIds": [
      "monolith"
    ]
  }
];
